import {
  useIsMobile,
  WSFormOld,
  WSText,
  WSTextInput
} from "@wingspanhq/fe-component-library";
import { IUserUpdateRequest } from "@wingspanhq/users";
import React from "react";
import * as Yup from "yup";

import { useMutationUpdateUserProfile } from "../../../query/users/mutations";
import styles from "./SettingsUpdateForms.module.scss";

import { queriesOnboarding } from "@query";
import { VerificationLevel } from "@wingspanhq/wingspan-api-sdk";
import { openIntercomMessage } from "../../../shared/utils/intercom";

interface FormProps {
  onSubmit: (data: any) => void;
  defaultValues?: any;
  onCancel?: (data: any) => void;
}

export const LegalLastNameForm: React.FC<FormProps> = ({
  onSubmit,
  defaultValues,
  onCancel
}) => {
  const isMobile = useIsMobile();
  const queryVerifications = queriesOnboarding.getOnboardingStatus.useQuery(
    undefined,
    { select: status => status.verifications }
  );
  const isVerified =
    queryVerifications.data?.tax === VerificationLevel.VERIFIED;

  const [updateUserProfile, { error: updateUserProfileError }] =
    useMutationUpdateUserProfile();

  const onFormSubmit = async (data: any) => {
    if (defaultValues.lastName && isVerified) {
      openIntercomMessage(
        `Hi there! I want to update my legal last name to "${data.lastName}".\n\n`
      );
      onSubmit(data);
      return;
    }

    const request: IUserUpdateRequest = {
      profile: {
        lastName: data.lastName
      }
    };
    await updateUserProfile(request, {
      onSuccess: () => {
        onSubmit(data);
      }
    });
  };
  return (
    <WSFormOld
      className={styles.form}
      onSubmit={onFormSubmit}
      defaultValues={defaultValues}
      validationSchema={Yup.object().shape({
        lastName: Yup.string().required("This field is required")
      })}
    >
      <WSFormOld.Field name="lastName">
        <WSFormOld.Input render={props => <WSTextInput {...props} />} />
      </WSFormOld.Field>
      <WSText.ParagraphSm weight="medium" className={styles.errorText} mt="XS">
        {updateUserProfileError?.response?.data["error"]}
      </WSText.ParagraphSm>

      <WSFormOld.SubmitButton
        name="update"
        type="submit"
        mt="2XL"
        fullWidth={isMobile}
      >
        {defaultValues.lastName && isVerified
          ? "Send request to customer support"
          : "Update"}
      </WSFormOld.SubmitButton>
    </WSFormOld>
  );
};
